<template>
  <section class="approveItem posire" v-loading="loading">
    <img v-if="approveData.applyUserFileUrl" class="userImg posiab" :src="approveData.applyUserFileUrl" />
    <img v-if="!approveData.applyUserFileUrl" class="userImg posiab" src="~images/user.png" />
    <!-- title -->
    <h2 class="title">{{approveData.applyUserName}}提交的{{approveData.busiRemarks}}</h2>
    <!-- title end -->
    <section
      class="clearPa msgItem"
      v-for="(item, index) in approveData.businessDataBeans"
      :key="index"
    >
      <article class="left label">{{item.title}}：</article>
      <article
        class="left value"
        :class="{
          error: item.type === 'amount'
        }"
      >{{item.value}}</article>
    </section>
    <!-- 底部信息 -->
    <section class="clearPa">
      <article class="left date">{{approveData.applyDate}}</article>
      <article class="right btnLine">
        <span class="primary cur passBtn" @click="approve(1)">同意</span>
        <span class="error cur" @click="approve(2)">拒绝</span>
      </article>
    </section>
    <!-- 底部信息 end -->
  </section>
</template>

<script>
import {
  approve,
} from 'api';
export default {
  props: {
    approveData: {
      type: Object,
      default: () => ({}),
    },
  },
  data () {
    return {
      loading: false,
    };
  },
  methods: {
    async approve (chooseResult) {
      const confirmRes = await this.$confirm(`是否${chooseResult === 1 ? '通过' : '拒绝'}该审核?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).catch(() => { // 取消删除
      });
      if (confirmRes === 'confirm') {
        // this.loading = true;
        let res = await approve({
          chooseResult,
          desc: '快速审核',
          busiId: this.approveData.busiId,
          busiCode: this.approveData.busiCode,
          // instId: this.approveData.instId,
          auditCode: 300008,
          orderId: this.approveData.busiId,
          verifyDesc: '',
          result: chooseResult,
          receipt: chooseResult === 1 ? 0 : true,
          reciveState: 0,
          load: 0,
          loadState: 0,
          receiptsStr: [],
        });
        if (!res.failed) {
          this.$message({
            type: 'success',
            message: '保存成功',
          });
          // this.loading = false;
          this.$emit('del', this.approveData);
        } else {
          // this.loading = false;
        }
      }
    },
  },
};
</script>

<style scoped lang="scss">
.approveItem{
  border: 1px solid #ededed;
  padding: 16px 16px 16px 34px;
  box-sizing: border-box;
  margin-bottom: 8px;
  .userImg{ // 头像
    width: 22px;
    height: 22px;
    border-radius: 50%;
    top: 16px;
    left: 8px;
  }
  .title{ // title
    color: #333;
    height: 22px;
    line-height: 22px;
    margin-bottom: 12px;
  }
  .msgItem{
    margin-bottom: 12px;
    color: #666;
    .label{
      margin-right: 8px;
    }
    .value{
      max-width: 160px;
    }
  }
  .date{
    color: #999;
    height: 14px;
    line-height: 14px;
  }
  .btnLine{
    height: 14px;
    line-height: 14px;
  }
  .passBtn{
    margin-right: 8px;
    height: 14px;
    line-height: 14px;
  }
}
</style>
